import { combineReducers } from "redux";
import scanReducer from "./scanReducer";

const reducers = combineReducers({
  scan: scanReducer,
});

export default reducers;
